// extracted by mini-css-extract-plugin
module.exports = {"processWidget":"ProcessWidget_processWidget__1Zf_H","processWidgetTitle":"ProcessWidget_processWidgetTitle__2mPtO","iconContainer":"ProcessWidget_iconContainer__2ZQTe"};